import React from 'react'
import { createPortal } from 'react-dom'
import { Typography } from '@musinsa/layer-components-desktop'
import { FigmaDialogBodyArea, FigmaDialogCard, FigmaDialogFooterArea, FigmaDialogOverlay, FigmaDialogTitleArea } from './styles'

interface Props {
  open: boolean
  title: string
  children?: React.ReactNode
  actions: React.ReactNode
}

/** @musinsa/layer-components-desktop Dialog(size="small") 형태의 확인 다이얼로그 */
export function FigmaDialog({ open, title, children, actions }: Props) {
  if (!open) return null
  return createPortal(
    <FigmaDialogOverlay>
      <FigmaDialogCard>
        <FigmaDialogTitleArea>
          <Typography name="base-title-s-semibold" colorToken="dialog-fg">
            {title}
          </Typography>
        </FigmaDialogTitleArea>
        {children && <FigmaDialogBodyArea>{children}</FigmaDialogBodyArea>}
        <FigmaDialogFooterArea>{actions}</FigmaDialogFooterArea>
      </FigmaDialogCard>
    </FigmaDialogOverlay>,
    document.body,
  )
}
